<template>
  <div class="input-box">
    <label v-if="label !== null" class="label-text">{{label}}</label>
    <validation-provider ref="validationInput" name="baseInputEditValidationProvider" :rules="rules" v-slot="{errors, valid}">
      <div class="form-group" :class="errors.length > 0 ? 'error' : ''">
        <input class="form-control" :id="id" :type="type"  placeholder="">
        <small class="error-text">{{errors[0]}}</small>
      </div>
    </validation-provider>
  </div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import { alpha, required } from 'vee-validate/dist/rules';
import validationMethodsMixin from "../../mixin/validationMethodsMixin";


export default {
  name: "BaseDateInput",
  mixins : [validationMethodsMixin],
  components : {ValidationProvider},
  data :() => {
    return {
      valid : null,
      id : Math.floor((Math.random() * 1000) + 1),
    };
  },
  props : {
    label : null,
    type : String,
    rules : String,
    inputModel : null
  },
  model: {
    prop: 'inputModel',
    event: 'change'
  },
  mounted() {
    let that=this;
    alpha.message =  'Not alpha numeric';
    extend("alpha", alpha);

    extend("required", {...required,
      message : required.message =  'Required'});

    const max_value = {
      message(field, params, data) {
        let maxValue = params[0];
        let value = params._value_;
        return `${value} is higher than maximum value ${maxValue}`
      },
      validate(value, args) {
        let maxValue = args[0];
        return parseInt(maxValue) >= parseInt(value);
      }
    };

    const min_value = {
      message(field, params, data) {
        let minValue = params[0];
        let value = params._value_;
        return `${value} is lower than minimum value ${minValue}`
      },
      validate(value, args) {
        let minValue = args[0];
        return parseInt(minValue) <= parseInt(value);
      }
    };

    const birthdate = {
      message(field, params, data) {
        let value = params._value_;
        return `${value} is not valid`
      },
      validate(value, args) {
        if(new Date(value) != null && typeof value == Date){
          return true
        }
        return false
      }
    };

    const tc_value = {
      message(field, params, data) {
        let value = params._value_;
        return `${value} is not Valid`
      },
      validate(value, args) {
        let tcno = value;
        if(value == '' || value == undefined) {
          return true;
        }
        var ree = /^[1-9]{1}[0-9]{10}$/;
        var tcno_val_result = true;

        if(!ree.test(tcno))
        {
          tcno_val_result = false;
        }
        else
        {
          let KimlikNo = tcno;
          if( ! KimlikNo.match(/^[0-9]{11}$/) )
          {
            tcno_val_result = false;
          }

          let pr1 = parseInt(KimlikNo.substr(0,1));
          let pr2 = parseInt(KimlikNo.substr(1,1));
          let pr3 = parseInt(KimlikNo.substr(2,1));
          let pr4 = parseInt(KimlikNo.substr(3,1));
          let pr5 = parseInt(KimlikNo.substr(4,1));
          let pr6 = parseInt(KimlikNo.substr(5,1));
          let pr7 = parseInt(KimlikNo.substr(6,1));
          let pr8 = parseInt(KimlikNo.substr(7,1));
          let pr9 = parseInt(KimlikNo.substr(8,1));
          let pr10 = parseInt(KimlikNo.substr(9,1));
          let pr11 = parseInt(KimlikNo.substr(10,1));

          if( (pr1+pr3+pr5+pr7+pr9+pr2+pr4+pr6+pr8+pr10) % 10 != pr11 ){
            tcno_val_result = false;
          }
          if( ( (pr1+pr3+pr5+pr7+pr9)*7 + (pr2+pr4+pr6+pr8)*9 ) % 10 != pr10 ){
            tcno_val_result = false;
          }
          if( ( (pr1+pr3+pr5+pr7+pr9)*8) % 10 != pr11 ){
            tcno_val_result = false;
          }
        }
        return tcno_val_result;
      }
    };

    extend("max_value", max_value)
    extend("min_value", min_value)
    extend("tc_validation",tc_value)
    extend("birthdate",birthdate)

    $("#"+this.id).daterangepicker({
      opens: 'right',
      singleDatePicker: true,
      showDropdowns: true,
      locale: {
        format: 'DD/MM/YYYY',
      }
    });
    $("#"+this.id).change(function (val){
      that.$emit("change",moment.utc($(this).val(),'DD/MM/YYYY'));
      that.$nextTick(()=>{
        $("#"+that.id).val(moment.utc(that.inputModel).format("DD/MM/YYYY"));
      })

    })
    $("#"+that.id).val(moment.utc(that.inputModel).format("DD/MM/YYYY"));
  },
  updated() {
  }
}
</script>

<style scoped>

</style>